export const sortTags = (tags: Array<string>) => {
  tags.splice(
    tags.findIndex((tag) => tag === null),
    1
  );

  if (!tags.find((tag) => tag === "Eksisterende")) {
    tags.push("Eksisterende");
  }

  tags.sort((a, b) => (a > b ? 1 : -1));
  return tags;
};
